import { css } from '@inter-ikea-kompis/web-component';
/**
 * Style for MediaCarousel.
 */
export default class MediaCarouselStyle {
    /**
     * @param options Options.
     * @param options.theme Theme.
     * @param options.layout ...
     * @returns Style.
     */
    static getStyle(options) {
        const { color, spacing } = options.theme;
        return css `
			:host {
				display: block;
				position: relative;
				height: unset;
			}

			.mediaSwiper {
				height: 100%;
			}

			.mediaPicker {
				padding-top: 2rem;
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-start;
				align-items: center;
				margin-left: ${2 / 16}rem;
			}

			.mediaPicker .thumbnail {
				display: flex;
				height: ${60 / 16}rem;
				width: ${60 / 16}rem;
				border-radius: ${2 / 16}rem;
				justify-content: center;
				align-items: center;
				box-shadow: 0 0 0 ${1 / 16}rem ${color.neutral.grey200};
				cursor: pointer;
				outline: none;
				margin-bottom: ${spacing.space50 / 16}rem;
			}

			.mediaPicker .thumbnail kompis-image {
				height: ${(60 - spacing.space25 / 2) / 16}rem;
				width: auto;
				overflow: hidden;
			}

			.mediaPicker .thumbnail.selectedThumbnail,
			.mediaPicker .thumbnail:focus {
				box-shadow: 0 0 0 ${2 / 16}rem ${color.neutral.grey900};
			}

			.mediaPicker .divider {
				width: ${spacing.space50 / 16}rem;
			}

			.showAllBtn {
				margin: 0 ${spacing.space50 / 16}rem ${spacing.space50 / 16}rem ${spacing.space50 / 16}rem;
			}

			video {
				max-width: 100%;
			}
		`;
    }
}
//# sourceMappingURL=MediaCarouselStyle.js.map